import type { EffectiveTaskViewHydraItem } from "@verbleif/lib/src/composables/Api/Type/TaskView/taskView.interface";
import { createGlobalState } from "@vueuse/core";
import { resourceKeys } from "../Query/resourceKeys";
import { createEffectiveViewsState } from "../ScopedViews/effectiveViewsState";

/** The effective task views of the signed-in user at the selected location, with view management and the list switcher. */
export const useTaskViews = createGlobalState(() => createEffectiveViewsState<EffectiveTaskViewHydraItem>({
  keys: resourceKeys.taskViews,
  collection: "effective_task_views",
  errorTitleKey: "tasks.sidebar.views_load_failed",
  errorFallbackTitle: "Failed to load task views",
}));
